var _mask, _g, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2604 0.00634766H1.76753C0.80361 0.0107075 0.0247532 0.951055 0.027 2.10776L0 16.8062L0.99072 16.8004L1.01814 2.2231L9.7426 9.11482C9.82344 9.17823 9.91789 9.21207 10.0145 9.21222C10.1096 9.21233 10.2027 9.17931 10.2825 9.11716L19.0093 2.34587L19.0096 14.7077C19.0105 15.2053 18.6754 15.6098 18.2607 15.6117H3.00328V16.8062H18.2607C19.2235 16.8017 20.0016 15.863 20.0003 14.7077L20 2.10485C20.0013 0.94953 19.2232 0.010865 18.2604 0.00634766Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 -7.19995H-2V21.6H22V-7.19995Z",
    fill: "#0E5AA7"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2012 1.2373H1.7083C1.64732 1.24265 1.58716 1.25736 1.5293 1.28106L9.03586 7.21146L9.97929 7.92221L18.498 1.31293C18.4045 1.26337 18.3034 1.23762 18.2012 1.2373Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22 -7.19995H-2V21.6H22V-7.19995Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f03f75dc323533ff810e9cb6c7ed4477.svg";
export { ForwardRef as ReactComponent };